import React, { useState, useEffect } from "react";
import { Modal, Table, Button, Space, Typography, Tag, Popconfirm, Spin, Card, Empty } from "antd";
import {
  CheckOutlined,
  CloseOutlined,
  SyncOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { BellOutlined } from "@ant-design/icons";
import { postRequest } from "../../services/mainApp.service";
import { useSelector, useDispatch } from "react-redux";
import ViewOrderModal from "../../components/PosComponentsFood/ViewOrderModal";
import CustomButton from "../NewComponents/CustomButton";
import { getOrderStatuses } from "../../utils/OrderPageFunctions";
// import { startConnection, onOrderUpdate } from "../../services/signalRService";
// import { startConnection, onOrderUpdate } from "../../services/signalRService";


const NewOrdersModal = ({ isOpen, setIsOpen, newOrders, orderStatusList, onUpdateOrders }) => {
  
  const dispatch = useDispatch();
    const { userBranchList } = useSelector((state) => state.authReducer);
  

  // calling the utils function for getting accept and cancel
  const { acceptStatus, cancelStatus } = getOrderStatuses(orderStatusList);

  // getting user data from redux
  const userData = useSelector((state) => state.authReducer);

  const [loadingButtons, setLoadingButtons] = useState({});
 

  // orderdetaisl items for expandable row
  const [expendedOrderItems, setExpendedOrderItems] = useState({});
  // expanded rows key
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);




  // view order detials modal ......................................................................
  const [viewOrderData, setViewOrderData] = useState(null);
  const [viewOrder, setViewOrder] = useState(false);

  const toggleViewOrder = () => {
    setViewOrder(!viewOrder);
  };
  const getOrderDetail = (record) => {
    if (!record || !record.OrderMasterId) {
      console.error("OrderMasterId is undefined in the record:", record);
      return;
    }

    setViewOrder(true);

    postRequest("getOrderDetail", {
      OperationId: 1,
      CompanyId: userData.CompanyId,
      OrderId: record.OrderMasterId,
      UserId: userData.UserId,
      UserIP: "192.1.1.1",
    })
      .then((response) => {
        setViewOrderData(response.data.DataSet);
      })
      .catch((error) => {
        setViewOrder(false);
        console.error(error);
      });
  };
  // view order detials modal ended.....................................................

  // handle status change
  const handleStatusChange = async (orderStatusId, orderDetials) => {


    if (!orderDetials?.OrderMasterId) return;

    try {
      const response = await postRequest("/UpdateOrderStatus", {
        OperationId: 2,
        OrderMasterId: orderDetials?.OrderMasterId,
        CompanyId: userData?.CompanyId,
        OrderStatusId: orderStatusId,
        DateFrom: "2022-01-13 00:00:00.000",
        DateTo: "2023-11-13 00:00:00.000",
        userId: userData?.UserId,
        AreaId: orderDetials?.AreaId,
        OrderSourceId: orderDetials?.OrderSourceId,
        AreaName: orderDetials?.AreaName,
        OrderNumber: orderDetials?.OrderNumber,
        OrderDate: orderDetials?.OrderDate,
      })
      .then((response) => {

        if (response.data.error === true) {
          message.error(response.data.errorMessage);
          return;
        }

        if (response.data.response === false) {
          message.error(response.data.DataSet.Table.errorMessage);
          return;
        }
  
        dispatch({ type: "REFRESH_STATS", payload: 1 });
        const data = response.data.DataSet;
        const { Table6 } = data;
        onUpdateOrders(Table6);
      })
      .catch((error) => {

        console.error("Error:", error);
      });

      
    } catch (error) {
      console.error("Error:", error);
    } 
  };

  // Table columns
  const columns = [
    {
      title: (
        <Typography.Title level={5} style={{ color: "gray" }}>
          Order Number
        </Typography.Title>
      ),
      dataIndex: "OrderNumber",
      key: "OrderNumber",
      align: "center",
      render: (orderNumber) => {
        // Extract the part after the last slash
        const lastPart = orderNumber?.split("/").pop();
        return lastPart;
      },
    },
    {
      title: (
        <Typography.Title level={5} style={{ color: "gray" }}>
          Customer Name
        </Typography.Title>
      ),
      dataIndex: "CustomerName",
      key: "CustomerName",
      align: "center",
    },
    {
      title: (
        <Typography.Title level={5} style={{ color: "gray" }}>
          Customer Phone
        </Typography.Title>
      ),

      dataIndex: "PhoneNumber",
      key: "PhoneNumber",
    },
    {
      title: (
        <Typography.Title level={5} style={{ color: "gray" }}>
          Area
        </Typography.Title>
      ),
      dataIndex: "AreaName",
      key: "AreaName",
      align: "center",
    },
    {
      title: (
        <Typography.Title level={5} style={{ color: "gray" }}>
          Amount
        </Typography.Title>
      ),
      dataIndex: "TotalAmountWithGST",
      key: "TotalAmountWithGST",
      align: "center",
    },

    {
      title: (
        <Typography.Title level={5} style={{ color: "gray" }}>
          Order Date
        </Typography.Title>
      ),
      dataIndex: "OrderDateTime",
      key: "OrderDateTime",
      align: "center",
    },
    {
      title: (
        <Typography.Title level={5} style={{ color: "gray" }}>
          Status
        </Typography.Title>
      ),
      dataIndex: "OrderStatus",
      key: "OrderStatus",
      render: (status) => {
        return (
          <span className="bg-yellow-50 border border-yellow-300 p-1 rounded-lg text-yellow-600">
            {status.toUpperCase()}
          </span>
        );
      },
    },
    {
      title: (
        <Typography.Title level={5} style={{ color: "gray" }}>
          Actions
        </Typography.Title>
      ),
      key: "actions",
      align: "center",
      render: (_, record) => (
        <Space>
          <>
            <Button type="text" onClick={() => getOrderDetail(record)}>
              <EyeOutlined />
            </Button>
            <ViewOrderModal
              data={viewOrderData}
              viewOrder={viewOrder}
              toggleViewOrder={toggleViewOrder}
              isMainPage={false}
              onUpdateOrders={onUpdateOrders} // Pass callback to nested child
              branchList={userBranchList || []}
            />
          </>
          <Popconfirm
                title="Are you sure to Accept this Order?"
                onConfirm={() => handleStatusChange(acceptStatus?.OrderStatusId, record)}
                okText="Yes"
                cancelText="No"
                okButtonProps={{ style: { backgroundColor: "#52c41a", borderColor: "#52c41a", color: "white" } }} // Green color for Yes
                cancelButtonProps={{ style: { backgroundColor: "#ff4d4f", borderColor: "#ff4d4f", color: "white" } }} // Red color for No
              >
          <CustomButton
            type="primary"
            text="Accept"
            icon={<CheckOutlined />}
            // onClick={() =>
            //   handleStatusChange(acceptStatus?.OrderStatusId, record)
            // }
            // loading={loadingButtons[record.OrderMasterId]}
            style={{
              backgroundColor: "#4CAF50",
            }}
          /></Popconfirm>
          <Popconfirm
                title="Are you sure to Cancel this Order?"
                onConfirm={() => handleStatusChange(cancelStatus?.OrderStatusId, record)}
                okText="Yes"
                cancelText="No"
                okButtonProps={{ style: { backgroundColor: "#52c41a", borderColor: "#52c41a", color: "white" } }} // Green color for Yes
                cancelButtonProps={{ style: { backgroundColor: "#ff4d4f", borderColor: "#ff4d4f", color: "white" } }} // Red color for No
              >
          <CustomButton
            type="danger"
            text="Cancel"
            icon={<CloseOutlined />}
            // onClick={() =>
            //   handleStatusChange(cancelStatus?.OrderStatusId, record)
            // }
            // loading={loadingButtons[record.OrderMasterId]}
            style={{
              backgroundColor: "#F44336",
            }}
          /></Popconfirm>
        </Space>
      ),
    },
  ];

  // expanded row table
  const ExpandedRowItems = ({ record }) => {
    const dataSource =
      record?.Table1?.map((item, index) => ({
        key: index,
        ProductDetailName: item.ProductDetailName,
        Quantity: item.Quantity,
        DiscountPercent: item.DiscountPercent,
        PriceWithGST: item.PriceWithGST,
      })) || [];

    return (
      <div
        style={{
          backgroundColor: "#f7f7f7",
          borderRadius: "8px",
          // padding: "16px",
        }}
      >
        <Table
          dataSource={dataSource}
          pagination={false}
          columns={[
            {
              title: "Item Name",
              dataIndex: "ProductDetailName",
              key: "ProductDetailName",
            },
            {
              title: "Quantity",
              dataIndex: "Quantity",
              key: "Quantity",
              align: "center",
            },
            {
              title: "Discount (%)",
              dataIndex: "DiscountPercent",
              key: "DiscountPercent",
              align: "center",
              render: (value) => `${value}%`,
            },
            {
              title: "Amount",
              dataIndex: "PriceWithGST",
              key: "PriceWithGST",
              align: "center",
              render: (value) => `Rs. ${value.toFixed(2)}`,
            },
          ]}
          rowKey={(item) => item?.OrderDetailId}
          size="small"
          bordered={false}
        />
      </div>
    );
  };

  // calling api for getting order items for expandablr row
  const getDetail = async (record) => {
    if (!record || !record.OrderMasterId) {
      console.error("OrderMasterId is undefined in the record:", record);
      return;
    }
    try {
      const response = await postRequest("getOrderDetail", {
        OperationId: 1,
        CompanyId: userData.CompanyId,
        OrderId: record.OrderMasterId,
        UserId: userData.UserId,
        UserIP: "192.1.1.1",
      });
    
      setExpendedOrderItems((prevData) => ({
        ...prevData,
        [record.OrderMasterId]: response.data.DataSet,
      }));
    } catch (error) {
      console.error(error);
    }
  };

  // handle expand
  const handleExpand = (expanded, record) => {
  
    if (expanded) {
      setExpandedRowKeys([record.OrderMasterId]);
      getDetail(record); // Fetch details
    } else {
      setExpandedRowKeys([]);
    }

  };

  const handleModalClose = () => {
    setIsOpen(false);
    setExpandedRowKeys([]);
    // setLatestOrders(newOrders);
  };

  return (
    <Modal
      title={null} // Remove the header
      centered
      visible={isOpen}
      closeIcon={null}
      onOk={() => setIsOpen(false)}
      onCancel={handleModalClose}
      style={{ borderRadius: "16px", overflow: "hidden" }}
      maskStyle={{
        backgroundColor: "rgba(0, 0, 0, 0.7)", // Darker mask shadow
      }}
      footer={null}
      width="1200px"
    >
      {
        newOrders.length > 0 &&
        <Typography.Title
        level={3}
        className="flex justify-center items-center gap-2"
      >
        Pending Orders
        <BellOutlined
          style={{
            fontSize: "2em", // Makes the bell icon larger than the text
            color: "black", // Matches the text color
          }}
          className="animate-shake bell_icon"
        />
      </Typography.Title>
      }
     

      <div>
       {
        newOrders.length > 0 ?  <Table
        columns={columns}
        dataSource={newOrders}
        rowKey={(record) => record.OrderMasterId} // Ensure rowKey is correct
        pagination={{ position: ["bottomRight"], pageSize: 5 }}
        expandable={{
          expandedRowRender: (item) => (
            <ExpandedRowItems
              record={expendedOrderItems[item.OrderMasterId]}
            />
          ),
          expandedRowKeys,
          onExpand: handleExpand,
        }}
        bordered
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "8px",
          overflow: "hidden",
        }}
      /> :   
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
       
        
      />
   
       }
      </div>
    </Modal>
  );
};

export default NewOrdersModal;
